module.exports = __webpack_public_path__ + "img/code.948933d8.svg";